import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import "./Agent_Applicant_data.css";
import Reminder_Date_Wrapper from "./Reminder_Date_Wrapper";
import VerificationModal from "./VerificationModal/VerificationModal";
import { useNavigate } from "react-router-dom";
import { postMiddleEntryPointAPI, postSaveTheAgentTeamMember, postSaveTheAgentTeamMemberTemp } from "../../../api";
import { toast } from "react-toastify";

const Agent_Applicant_data = ({
  setLoading,
  AgentApplicantTiButton,
  API_Data,
  pointerID,
  getAllDataOfViewUpdateFunction,
}) => {
  const navigate = useNavigate();
  const accountType = localStorage.getItem("AQATO_SuperAdminAccountType") || "";
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [userShowVerificationModal, setUserShowVerificationModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const [agentMembers, setAgentMembers] = useState([]);
  const [selectedAgentMember, setSelectedAgentMember] = useState("");
  const [showEditButtonForMember, setShowEditButtonForMember] = useState(false);
  const [selectedAgentLabelDynamic, setSelectedAgentLabelDynamic] = useState("");
  const contentRef = useRef(null);


  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.clientHeight); // Set height based on content column
    }
    if(API_Data?.agent_members != undefined){
      setAgentMembers(API_Data?.agent_members);
    }
    setSelectedAgentMember(API_Data?.user_team_id);
    setSelectedAgentLabelDynamic(API_Data?.agent_user_contract_details);
    // console.log(API_Data?.agent_members, "API_Data?.agent_members");
  }, [API_Data]);

  const handleRequestAdditionalInfoModalOpen = () => {
    setShowVerificationModal(true);
  };

  const handleOnChangeTeamMemberAllocation = (select_member) => {
    setSelectedAgentMember(select_member);
    setShowEditButtonForMember(true);
  }

  const handleUserRequestAdditionalInfoModalOpen = () => {
    setUserShowVerificationModal(true);
  };


    const handleOpenGatesofStage1_Editor = async (email) => {
      // Check whether request is from same link 
      setLoading(true);
      var formData = new FormData();
      formData.append("email", email);
  
      try {
  
        const loginResponse = await postMiddleEntryPointAPI(formData);
        setLoading(false);
        
        
  
        const responseData = loginResponse?.data?.response;
  
    
        if (responseData && responseData?.response === true) {
          const token = responseData.token;
          // const encryptedToken = encryptData(token);
    
  
          // localStorage.setItem("account_type", responseData?.data?.account_type);
          // localStorage.setItem("isLoggedIn", true);
          // localStorage.setItem("encryptedToken", encryptedToken);
          // localStorage.setItem("userId", responseData?.data?.user_id);
    
          const jumping_url = process.env.REACT_APP_AQATO_ADMIN_PORTAL_AGENT_URL_URL+"/user/middle_entry/access_granted?redirect_to=dashboard&account_type="+responseData?.data?.account_type+"&encryptedToken="+token+"&userId="+responseData?.data?.user_id+"&userName="+responseData?.data?.user_name;
  
          // console.log(jumping_url);
          window.open(jumping_url, "_blank");
  
        
  
  
        } else {


  
          if (responseData?.error_msg === "Invalid Username Or Password") {
            toast.error("Invalid email or password. Please try again.");
          } else if (responseData?.error_msg) {
            toast.error(responseData.error_msg);
          }
  
        }
  
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
  
  
      // END
    }

  const saveTheAgentTeamMember = async() => {
    // console.log(pointerID, "pointerID");
    // console.log(selectedAgentMember, "selectedAgentMember");
    const formData = new FormData();
    formData.append("pointer_id", pointerID);
    formData.append("user_team_id", selectedAgentMember);
    // return;
     try {
      setLoading(true);
      const response = await postSaveTheAgentTeamMember(formData);
      setLoading(false);

      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {
        setShowEditButtonForMember(false);
        setSelectedAgentLabelDynamic(response?.data?.response?.data);
      } else {
        setLoading(false);
        console.error(
          "Error fetching data:",
          response?.data?.error_msg || "Unknown error"
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  }




  const saveTheAgentTeamMemberTemp = async(selectedValue) => {
    // console.log(pointerID, "pointerID");
    // console.log(selectedAgentMember, "selectedAgentMember");
    const formData = new FormData();
    formData.append("pointer_id", pointerID);
    formData.append("user_team_id", selectedValue);
    // return;
     try {
      // setLoading(true);
      const response = await postSaveTheAgentTeamMemberTemp(formData);
      // setLoading(false);

      if (
        response &&
        response?.data &&
        response?.data?.response &&
        response?.data?.response?.response === true &&
        response?.data?.response?.data
      ) {
        // setShowEditButtonForMember(false);
        // console.log(response?.data?.response?.data, "response?.data?.response?.data");

        setSelectedAgentLabelDynamic(response?.data?.response?.data);
      } else {
        setLoading(false);
        console.error(
          "Error fetching data:",
          response?.data?.error_msg || "Unknown error"
        );
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  }


  const handleChangeUserTeamMember = (e) => {
   const selectedValue = e.target.value;
   handleOnChangeTeamMemberAllocation(selectedValue);
   
   if(API_Data?.user_team_id === selectedValue){
    setShowEditButtonForMember(false);
   }

   saveTheAgentTeamMemberTemp(selectedValue);

  }


  const handleVerificationModalClose = () => {
    setShowVerificationModal(false);
  };


  const handleUserVerificationModalClose = () => {
    setUserShowVerificationModal(false);
    getAllDataOfViewUpdateFunction(pointerID);
    setSelectedAgentMember(API_Data?.user_team_id);
    setShowEditButtonForMember(false);

  };

  const handleNavigateToApplicationTransfer = () => {
    navigate("/admin/application_manager/view_application/transfer_applicant", {
      state: { pointerID: pointerID },
    });
  };

  const handleToggleImageModal = () => {
    setShowImageModal((prev) => !prev);
  };

  return (
    <>
      <div className="Sub-heading-title">
        <Row>
          {/* Content section */}
          <Col lg={8} ref={contentRef}>

            {accountType !== "head_office" && (
              <Row>
                <Col>
                  <div
                    style={{
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {API_Data?.heading_text_4}
                  </div>
                </Col>
              </Row>
            )}

            <Row className="align-items-center">
              <Col className="d-flex align-items-center">
                <div
                  style={{
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {API_Data?.heading_text_1}
                </div>
                {API_Data?.profile_path && (
                  <button
                    onClick={handleToggleImageModal}
                    className="btn btn-sm btn_green_yellow mx-2 p-0 px-1"
                    style={{ marginLeft: "8px" }}
                  >
                    
                    <i className="bi bi-person-bounding-box icon-transition"></i>
                  </button>
                )}
              </Col>
            </Row>

            {accountType !== "head_office" && (
              <Row>
                <Col>
                  <div
                    style={{
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {API_Data?.heading_text_2}
                    {API_Data?.agent_contract_details !== "" && (
                      <button
                        onClick={handleRequestAdditionalInfoModalOpen}
                        className="btn btn-sm btn_green_yellow mx-2 p-0 px-1"
                      >
                        <i className="bi bi-person-check-fill icon-transition"></i>
                      </button>
                    )}

                    {(API_Data?.agent_user_contract_details !== "" && accountType !== 'aqato_read_only') && (
                      <button
                        onClick={handleUserRequestAdditionalInfoModalOpen}
                        className={"btn btn-sm btn_green_yellow mx-0 p-0 px-1 " + (API_Data?.agent_contract_details === "" ? "ms-1" : "")}
                      >
                        <i className="bi bi-person-circle icon-transition"></i>
                      </button>
                    )}

                  </div>
                </Col>
              </Row>
            )}

            {(accountType !== "head_office") && (
              <Row>
                <Col>
                  <div
                    style={{
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {API_Data?.heading_text_3}

                    {accountType !== 'aqato_read_only' && (
                      <>
                      <button
                      onClick={handleNavigateToApplicationTransfer}
                      className="btn btn-sm btn_green_yellow mx-2 p-0 px-1"
                      // disabled = {API_Data?.is_doc_deleted === "1" ? true : false}
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>
                    <button
                    title="Login to Agent Portal"
                      className="btn btn-sm btn_green_yellow p-0 px-1"
                      onClick={() =>
                        handleOpenGatesofStage1_Editor(API_Data?.heading_text_3)
                      }
                    >
                      <i className="bi bi-arrow-up-right-circle bi-lg"></i>
                    </button>
                    </>
                    )}
                    
                  </div>
                </Col>
              </Row>
            )}

          </Col>

          {/* Reminder section */}
          <Col lg={4}>

            {(accountType !== "head_office" && accountType !== "aqato_read_only") && (
              <Reminder_Date_Wrapper
                setLoading={setLoading}
                AgentApplicantTiButton={AgentApplicantTiButton}
                API_Data={API_Data}
                pointerID={pointerID}
                getAllDataOfViewUpdateFunction={getAllDataOfViewUpdateFunction}
              />
            )}

          </Col>
        </Row>
      </div>

      <Modal
        show={showImageModal}
        onHide={handleToggleImageModal}
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#055837" }}>
            Passport Size Photo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={API_Data?.profile_path}
            alt="Passport Size Photo"
            style={{
              borderRadius: "10px",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              border: "2px solid #fecc00",
              margin: "0 auto",
            }}
          />
        </Modal.Body>
      </Modal>

      <VerificationModal
        show={showVerificationModal}
        onClose={handleVerificationModalClose}
        onYes={handleRequestAdditionalInfoModalOpen}
        Title="Additional Contact Details"
        Message={
          <span style={{ fontWeight: "bold", color: "black" }}>
            {API_Data?.agent_contract_details}
          </span>
        }
      />


      <VerificationModal
        show={userShowVerificationModal}
        onClose={handleUserVerificationModalClose}
        onYes={handleUserRequestAdditionalInfoModalOpen}
        Title="Case Manager"
        Message={
          <>
          <div className="d-flex w-100">
          <select className="form-select" onChange={(e) => {
          handleChangeUserTeamMember(e);
          }} 
          disabled={!showEditButtonForMember}
          value={selectedAgentMember}>
            
            {agentMembers.length > 0 && agentMembers.map((member, index) => (
              <option key={index} value={member?.id}>
                {member.name} {member.is_admin === 'yes' ? ' (Admin)' : ''}
              </option>
            ))}
            
          </select>
          {showEditButtonForMember === true ? (
            <button 
            onClick={() => {
              saveTheAgentTeamMember();
            }}
            className="btn btn_green_yellow my-2 mx-2">
              <i className="bi bi-check-lg"></i>
            </button>
          ) : (
            <button 
              onClick={() => {
                setShowEditButtonForMember(true);
              }}
              className="btn btn_green_yellow my-2 mx-2">
                <i className="bi bi-pencil-square"></i>
              </button>
          )}
          
          </div>
          <p>{selectedAgentLabelDynamic}</p>
          </>
        }
      />
    </>
  );
};

export default Agent_Applicant_data;















// import React, { useState, useEffect, useRef } from "react";
// import { Row, Col, Modal } from "react-bootstrap";
// import "./Agent_Applicant_data.css";
// import Reminder_Date_Wrapper from "./Reminder_Date_Wrapper";
// import VerificationModal from "./VerificationModal/VerificationModal";
// import { useNavigate } from "react-router-dom";

// const Agent_Applicant_data = ({
//   API_Data,
//   pointerID,
//   getAllDataOfViewUpdateFunction,
// }) => {
//   const navigate = useNavigate();
//   const accountType = localStorage.getItem("AQATO_SuperAdminAccountType") || "";
//   const [showVerificationModal, setShowVerificationModal] = useState(false);
//   const [showImageModal, setShowImageModal] = useState(false);
//   const [contentHeight, setContentHeight] = useState(0);
//   const contentRef = useRef(null);

//   useEffect(() => {
//     if (contentRef.current) {
//       setContentHeight(contentRef.current.clientHeight); // Set height based on content column
//     }
//   }, [API_Data]);

//   const handleRequestAdditionalInfoModalOpen = () => {
//     setShowVerificationModal(true);
//   };

//   const handleVerificationModalClose = () => {
//     setShowVerificationModal(false);
//   };

//   const handleNavigateToApplicationTransfer = () => {
//     navigate("/admin/application_manager/view_application/transfer_applicant", {
//       state: { pointerID: pointerID },
//     });
//   };

//   const handleToggleImageModal = () => {
//     setShowImageModal((prev) => !prev);
//   };

//   return (
//     <>
//       <div className="Sub-heading-title">
//         <Row>
//           {/* Content section */}
//           <Col lg={8} ref={contentRef}>
//             {accountType !== "head_office" && (
//               <Row>
//                 <Col>
//                   <div
//                     style={{
//                       fontWeight: "bold",
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                     }}
//                   >
//                     {API_Data?.heading_text_4}
//                   </div>
//                 </Col>
//               </Row>
//             )}

//             <Row className="align-items-center">
//               <Col className="d-flex align-items-center">
//                 <div
//                   style={{
//                     fontWeight: "bold",
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                   }}
//                 >
//                   {API_Data?.heading_text_1}
//                 </div>
//                 {API_Data?.profile_path && (
//                   <button
//                     onClick={handleToggleImageModal}
//                     className="btn btn-sm btn_green_yellow mx-2 p-0 px-1"
//                     style={{ marginLeft: "8px" }}
//                   >
//                     <i className="bi bi-person-circle icon-transition"></i>
//                   </button>
//                 )}
//               </Col>
//             </Row>

//             {accountType !== "head_office" && (
//               <Row>
//                 <Col>
//                   <div
//                     style={{
//                       fontWeight: "bold",
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                     }}
//                   >
//                     {API_Data?.heading_text_2}
//                     {API_Data?.agent_contract_details !== "" && (
//                       <button
//                         onClick={handleRequestAdditionalInfoModalOpen}
//                         className="btn btn-sm btn_green_yellow mx-2 p-0 px-1"
//                       >
//                         <i className="bi bi-person-check-fill icon-transition"></i>
//                       </button>
//                     )}
//                   </div>
//                 </Col>
//               </Row>
//             )}

//             {accountType !== "head_office" && (
//               <Row>
//                 <Col>
//                   <div
//                     style={{
//                       fontWeight: "bold",
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                     }}
//                   >
//                     {API_Data?.heading_text_3}
//                     <button
//                       onClick={handleNavigateToApplicationTransfer}
//                       className="btn btn-sm btn_green_yellow mx-2 p-0 px-1"
//                     >
//                       <i className="bi bi-pencil-square"></i>
//                     </button>
//                   </div>
//                 </Col>
//               </Row>
//             )}
//           </Col>

//           {/* Reminder section */}
//           <Col lg={4}>
//             {accountType !== "head_office" && (
//               <Reminder_Date_Wrapper
//                 API_Data={API_Data}
//                 pointerID={pointerID}
//                 getAllDataOfViewUpdateFunction={getAllDataOfViewUpdateFunction}
//               />
//             )}
//           </Col>
//         </Row>
//       </div>

//       <Modal
//         show={showImageModal}
//         onHide={handleToggleImageModal}
//         centered
//         dialogClassName="custom-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ fontWeight: "bold" ,color:"#055837"}}>Profile</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="text-center">
//           <img
//             // src="https://wallpapers.com/images/featured/virat-kohli-yc8dfpcjssp3s4se.jpg"
//             src={API_Data?.profile_path}
//             alt="Profile"
//             style={{
//               borderRadius: "10px",
//               width: "460px",
//               height: "300px", 
//               objectFit: "cover",
//               border: "2px solid #fecc00",
//               margin: "0 auto", 
//             }}
//           />
//         </Modal.Body>
//       </Modal>

//       <VerificationModal
//         show={showVerificationModal}
//         onClose={handleVerificationModalClose}
//         onYes={handleRequestAdditionalInfoModalOpen}
//         Title="Additional Contact Details"
//         Message={
//           <span style={{ fontWeight: "bold", color: "black" }}>
//             {API_Data?.agent_contract_details}
//           </span>
//         }
//       />
//     </>
//   );
// };

// export default Agent_Applicant_data;